import { useCallback, useMemo } from 'react';

import {
  PickTimesPerWeek,
  DateSlotsPerWeek,
} from '../../components/WeekCalendarContainer';
import { WeekEntry } from '../../utils/weekly';

export default function useWeeklyAvailability(
  weekEntries: WeekEntry[],
  pickTimesPerWeek: PickTimesPerWeek,
  dateSlotsPerWeek: DateSlotsPerWeek
) {
  const availableWeekEntries = useMemo(
    () => weekEntries.filter((w) => w.id in pickTimesPerWeek),
    [weekEntries, pickTimesPerWeek]
  );

  const availableDays = useMemo(
    () =>
      availableWeekEntries
        .map((week) => Object.keys(dateSlotsPerWeek[week.id] || {}))
        .flat(),
    [availableWeekEntries, dateSlotsPerWeek]
  );

  const isDayAvailable = useCallback(
    (datestring: string) => availableDays.includes(datestring),
    [availableDays]
  );

  return {
    availableWeekEntries,
    isDayAvailable,
  } as const;
}
